{
  "sideNavOffset": -100,
  "getArticleStoryUrlPath": "/jsonapi/node/story_page",
  "articleTypeStory": "story_page",
  "articleTypeDataResource": "dataResource",
  "articleTypeDictionary": "dictionaryGlossary",
  "useCacheBuster": {
    "getArticleDatasets": false,
    "getDataDictionaryById": false,
    "getStoryPageById": false,
    "getSlug": false,
    "getNavigationMenus": false,
    "getAllNavigationalTopics": false,
    "getDatasetById": false,
    "getDownloadResources": false,
    "getDatasetVersionResources": false,
    "getDatasetVersions": false,
    "getInteractiveData": false,
    "getTopicData": false,
    "getSubtopicData": false,
    "getTopicSiblingsData": false,
    "getSubtopicSiblingsData": false,
    "getDependentDatasets": false,
    "fetchTrendingStats": false,
    "fetchFilters": false,
    "fetchSearchResults": false,
    "getTypeahead": false,
    "getDatasetsWithMetaData": false,
    "getContactPageData": false,
    "getDatasetContactInfo": false,
    "getSearchMetaData": false,
    "getRecentCaseStudies": false,
    "getHomepage": false
  },
  "articleComponentTypes": {
    "componentTypeTextBlock": "basicTextBlock",
    "componentTypeMedia": "media",
    "componentTypeQuote": "quote",
    "componentTypeFaq": "faq",
    "componentTypeFaqList": "faqList",
    "componentTypeImageText": "imageText",
    "componentTypeResources": "resources",
    "componentTypeCallouts": "callouts",
    "componentTypeKeyInfoList": "keyFindings",
    "componentTypeCitations": "fieldRefCitations",
    "componentTypeDictionary": "dictionary",
    "componentTypeTable": "fieldWysiwygTable",
    "componentTypeCarousel": "data_story_carousel",
    "componentTypeSingleResource": "singleResource",
    "componentTypeRelatedResources": "relatedResources"
  },
  "contactDefaultContact": "",
  "contactDefaultDescription": "Didn't find the answer you were looking for?",
  "contactDefaultHeader": "Contact us",
  "contactDefaultButtonLabel": "Email Support",
  "displayContexts": {
    "DATA_RESOURCE": "data resource"
  },
  "faqDisplayLimit": 5,
  "interactiveDatasetParam": "data",
  "datasetSubBaseURL": "https://public.govdelivery.com/accounts/USCMS/subscriber/new",
  "datasetSubTarget": "_blank",
  "datasetResourcesTitle": "Resources for Using and Understanding the Data",
  "datasetResourcesFeaturedTitle": "Resources",
  "datasetPrivacyLevelDictionary": {
    "public_use": "Public Use File (Free)",
    "limited_data": "Limited Data File (Fee)",
    "research_identifiable": "Research Identifiable File (Fee)"
  },
  "datasetVersionDisplayLimit": 6,
  "datasetRelatedParentLabel": "Related datasets in",
  "datasetRelatedGrandparentLabel": "Recently updated in",
  "datasetRelatedDisplayLimit": 3,
  "dynamicTableOverflowWidthArticle": 800,
  "dynamicTableOverflowWidthInteractive": 1040,
  "dynamicTableColumnMinimum": 66,
  "dynamicTableColumnMaximum": 222,
  "homepageTopicLinksLabel": "Key topics",
  "homepageFeaturedVisLabel": "Featured visualization",
  "homepageChartMetaTopicLabel": "Topic:",
  "homepageChartMetaDatasetUsedLabel": "Dataset used:",
  "wddseAccentColorPalette": [
    "#7a00c7",
    "#be22cf",
    "#02bfe7",
    "#046b99",
    "#4e0484",
    "#0071bc",
    "#e750ed",
    "#b33aff",
    "#112e51",
    "#67c2ff",
    "#fb98ff",
    "#640d6d"
  ],
  "homepageChartCommonTooltipConfig": {
    "backgroundColor": "#081628",
    "bodyAlign": "center",
    "bodyFont": {
      "size": 14,
      "weight": "bold",
      "family": "'Rubik', 'sans-serif'",
      "color": "#fff"
    },
    "titleFont": {
      "size": 14,
      "weight": "normal",
      "family": "'Rubik', 'sans-serif'",
      "color": "#fff"
    },
    "titleAlign": "center",
    "displayColors": false,
    "padding": {
      "x": 9,
      "y": 16
    }
  },
  "searchLimit": 10,
  "searchIfGreaterThan": 2,
  "defaultSearchSortValue": "Relevancy",
  "searchSortOptions": {
    "Relevancy": [
      ["sort_by[search_api_relevance]", "DESC"]
    ],
    "Last updated": [
      ["sort_by[updated]", "DESC"]
    ],
    "A - Z": [
      ["sort_by[title]", "ASC"]
    ],
    "Z - A": [
      ["sort_by[title]", "DESC"]
    ]
  },
  "bundleTypes": {
    "DATASET": "dataset",
    "STORY": "story_page",
    "NAVIGATIONAL_TOPIC": "navigational_topics",
    "DATA_DICTIONARY": "data_dictionary_page",
    "DATA_RESOURCE": "data_resource_page",
    "LOOKUP_TOOL": "look_up_tool",
    "CONTACT_PAGE": "contact_page",
    "CATEGORIES_PAGE": "browse_by_category",
    "SITEMAP_PAGE": "sitemap_page",
    "LOOKUP_TOOL_PAGE": "look_up_tool",
    "API_DOCS_PAGE": "api_page",
    "TOPIC_PAGE": "topic_page",
    "GLOSSARY": "glossary"
  },
  "searchTrendingDataTypes": [
    {
      "key": "trending_by_download",
      "label": "Most Downloaded",
      "priority": 2
    },
    {
      "key": "trending_by_view",
      "label": "Most Viewed",
      "priority": 1
    }
  ],
  "changelogParam": "changelog",
  "apiDocsParam": "api-docs",
  "searchShortDescriptionLength": 290,
  "searchFullDescriptionLength": 1000,
  "mockDelayResponse": 0,
  "paginationMaxPages": 9,
  "paginationMaxPagesMobile": 5,
  "paginationShowDotDotDot": true,
  "paginationShowLastPage": true,
  "disableMobileSiteWarning": false,
  "defaultErrorMsg": "Oops, an error has occurred.",
  "typeaheadMaxRows": 5,
  "mobileTypeaheadMaxRows": 3,
  "topicMainDataUrl": "/jsonapi/node/topic_page",
  "subtopicMainDataUrl": "/jsonapi/node/subtopic_page",
  "topicTaxonomyUrl": "/jsonapi/taxonomy_term/navigational_topics",
  "topicRelatedDatasetsDisplayLimit": 3,
  "topicSubtopicCaseStudyConfig": {
    "subheader": "Data stories",
    "header": "Learn how people like you succeed with data.",
    "defaultButtonLabel": "Read case study",
    "spotlightCard": {
      "header": "Create a case study",
      "description": "Get the tips and advice you need to help craft your own story using CMS data.",
      "cta": {
        "label": "Submit a case study",
        "url": "DataNavigator@cms.hhs.gov"
      }
    }
  },
  "topicSubtopicFilters": [
    "All subtopics"
  ],
  "topicSubtopicSort": [
    "Last updated",
    "Top viewed",
    "A - Z",
    "Z - A"
  ],
  "createCaseStudySubjectLine": "Submit a case study",
  "staticAssetBaseRemainder": "/sites/default/files",
  "metaOrganizationName": " | CMS Data",
  "metaDefaultSiteTitle": "Data.CMS.gov",
  "metaDefaultSiteDescription": "A federal government website managed by the Centers for Medicare & Medicaid Services. Data.CMS.gov has datasets about Medicare Fee-For-Service, special programs and initiatives, and the Health Insurance Marketplace. This includes information on providers who accept Medicare, services and procedures delivered by providers, and qualified health plans.",
  "filterFormComparators": [
    {
      "label": "Equals",
      "value": "="
    },
    {
      "label": "Not equal",
      "value": "<>"
    },
    {
      "label": "In",
      "value": "IN"
    },
    {
      "label": "Not In",
      "value": "NOT IN"
    },
    {
      "label": "Less than",
      "value": "<"
    },
    {
      "label": "Less than or equal to",
      "value": "<="
    },
    {
      "label": "Greater than",
      "value": ">"
    },
    {
      "label": "Greater than or equal to",
      "value": ">="
    },
    {
      "label": "Contains",
      "value": "CONTAINS"
    },
    {
      "label": "Does not contain",
      "value": "NOT_CONTAINS"
    },
    {
      "label": "Is missing",
      "value": "IS NULL"
    },
    {
      "label": "Is not missing",
      "value": "IS NOT NULL"
    },
    {
      "label": "Starts with",
      "value": "STARTS_WITH"
    },
    {
      "label": "Ends with",
      "value": "ENDS_WITH"
    },
    {
      "label": "Between",
      "value": "BETWEEN"
    }
  ],
  "filterFormConjunctions": [
    {
      "label": "And",
      "value": "AND"
    },
    {
      "label": "Or",
      "value": "OR"
    }
  ],
  "filterFormInputsDisabledByComparator": ["IS NULL", "IS NOT NULL"],
  "filterFormInputsMultiValue": ["IN", "NOT IN"],
  "filterFormInputRangeValue": ["BETWEEN"],
  "filterFormPlaceholders": {
    "conjunction": "Select conjunction",
    "column": "Select column",
    "comparator": "Select condition",
    "filterValue": "Enter value"
  },
  "apiDocsPathAlt": "/apidocs",
  "apiDocsPath": "/api-docs",
  "toolsPath": "/tools",
  "previewParam": "preview",
  "defaultHeader": "wddse-spa",
  "creator": {
    "@type": "Organization",
    "name": "Centers for Medicare & Medicaid Services",
    "url": "https://www.cms.gov"
  },
  "license": "https://creativecommons.org/publicdomain/zero/1.0"
}
